import { useRoleAccess } from "@/features/auth/model/useRoleAccess";
import { useModuleEnabled } from "@/features/manifest/model/useManifest";
import { useModulePermissions } from "@/features/manifest/model/useModulePermission";

/**
 * Header clock and self clock-in/out are separate from opening the Time
 * Tracker page: workers only need volunteer_hours view/create/edit on the
 * matrix, not every nav permission tied to that module.
 */
export function useVolunteerSelfClockAccess() {
  const { role } = useRoleAccess();
  const hoursOn = useModuleEnabled("volunteer_hours");
  const { hasCapability, loading, fullAccess } = useModulePermissions();

  const isWorker =
    role === "OWNER" ||
    role === "ADMIN" ||
    role === "STAFF" ||
    role === "VOLUNTEER" ||
    role === "MENTOR";

  const hasHoursMatrixAccess =
    fullAccess ||
    hasCapability("volunteer_hours", "view") ||
    hasCapability("volunteer_hours", "create") ||
    hasCapability("volunteer_hours", "edit");

  const shouldUseClock =
    hoursOn && isWorker && (loading || hasHoursMatrixAccess);

  return {
    hoursOn,
    isWorker,
    hasHoursMatrixAccess,
    shouldUseClock,
    permissionsLoading: loading,
  };
}
